

import { Spinner } from '@/components/ui/spinner';

const LoadingState = () => {
  return (
    <div className="container flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <Spinner className="mx-auto h-8 w-8 mb-4" />
        <p className="text-muted-foreground">Loading subscription information...</p>
      </div>
    </div>
  );
};

export default LoadingState;
